module.exports = __webpack_public_path__ + "img/m_top_content&technic.d9b44df2.jpg";